module.exports = __webpack_public_path__ + "static/media/not-allowed.703cf4e5.svg";